import { useMytaverseEvent } from '@core/dashboard/providers';
import { isMapFeatureFlagEnabled } from '@helpers/events';

export const MapFeatureFlagSlug = {
  ToggleView: 'toggle-view',
} as const;

// Returns whether a map feature flag is enabled for the current room's map.
// Defaults to enabled when the slug has no override (or the map is unknown).
export const useMapFeatureFlag = (slug: string): boolean => {
  const { currentEvent, currentRoom } = useMytaverseEvent();

  return isMapFeatureFlagEnabled(currentEvent, currentRoom?.map?.mapId, slug);
};
